import { lazy } from 'react';
const IouApproval = lazy(() => import('./iouApproval'));

const iouApprovalRoutes = [
  {
    path: '/iou-approval',
    component: IouApproval
  }
];

export default iouApprovalRoutes;
